import { useEffect, useState } from "react";
import { StellarWallet } from "../../core/types/wallet";

export function useStellarWallets(): {
  wallets: StellarWallet[];
} {
  const [wallets, setWallets] = useState<StellarWallet[]>([]);

  useEffect(() => {
    const initializeWallets = async () => {
      if (typeof window === "undefined") return;

      try {
        const { allowAllModules: initializeAllModules } = await import(
          "@creit.tech/stellar-wallets-kit"
        );
        const { LedgerModule } = await import(
          "@creit.tech/stellar-wallets-kit/modules/ledger.module"
        );
        const { formatStellarWallet } = await import(
          "../../services/internal/stellarService.client"
        );
        const modules = [...initializeAllModules(), new LedgerModule()];

        const promises = modules.map(async (module) => {
          const isAvailable = await module.isAvailable();

          return {
            module,
            isAvailable,
          };
        });

        const results = await Promise.all(promises);

        const formattedWallets = results.map((result) =>
          formatStellarWallet(result.module, result.isAvailable)
        );

        setWallets(formattedWallets);
      } catch (error) {
        console.error("Failed to initialize stellar wallets:", error);
        setWallets([]);
      }
    };

    initializeWallets();
  }, []);

  return {
    wallets,
  };
}
